import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
import { defineComponent as _defineComponent } from 'vue';
import { computed, getCurrentInstance, ref } from 'vue';
import { abbreviateNumber } from '~/assets/helper/functions';
import { isFundSetupCompletionLeafKey, sustainableObjectiveFormCompletionSectionLabelKey } from '~/constants/fundSetupCompletion';
import { FundStrategy, useGetAccountQuery, useGetFundSetupStateLazyQuery, useDelFundsMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'CardFund',
  props: {
    fund: null,
    hasSfdrReport: {
      type: Boolean
    }
  },
  emits: ["deleted"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var companyCount = computed(function () {
      var _ref2, _props$fund$ventures$, _props$fund$ventures, _props$fund$ventureId;
      return (_ref2 = (_props$fund$ventures$ = (_props$fund$ventures = props.fund.ventures) === null || _props$fund$ventures === void 0 ? void 0 : _props$fund$ventures.length) !== null && _props$fund$ventures$ !== void 0 ? _props$fund$ventures$ : (_props$fund$ventureId = props.fund.ventureIds) === null || _props$fund$ventureId === void 0 ? void 0 : _props$fund$ventureId.length) !== null && _ref2 !== void 0 ? _ref2 : 0;
    });
    var ventureNames = computed(function () {
      var _props$fund$ventures$2, _props$fund$ventures2;
      var names = (_props$fund$ventures$2 = (_props$fund$ventures2 = props.fund.ventures) === null || _props$fund$ventures2 === void 0 ? void 0 : _props$fund$ventures2.map(function (v) {
        return v === null || v === void 0 ? void 0 : v.name;
      }).filter(Boolean)) !== null && _props$fund$ventures$2 !== void 0 ? _props$fund$ventures$2 : [];
      return _toConsumableArray(names).sort(function (a, b) {
        return a.localeCompare(b);
      });
    });
    var _useGetAccountQuery = useGetAccountQuery(),
      accountResult = _useGetAccountQuery.result;
    var account = computed(function () {
      var _accountResult$value$, _accountResult$value;
      return (_accountResult$value$ = (_accountResult$value = accountResult.value) === null || _accountResult$value === void 0 ? void 0 : _accountResult$value.getAccount) !== null && _accountResult$value$ !== void 0 ? _accountResult$value$ : {
        id: ''
      };
    });
    var portfolioTotalCompanies = computed(function () {
      var _account$value$ventur, _account$value, _account$value$ventur2;
      return (_account$value$ventur = (_account$value = account.value) === null || _account$value === void 0 ? void 0 : (_account$value$ventur2 = _account$value.ventureLinks) === null || _account$value$ventur2 === void 0 ? void 0 : _account$value$ventur2.length) !== null && _account$value$ventur !== void 0 ? _account$value$ventur : 0;
    });
    var _useGetFundSetupState = useGetFundSetupStateLazyQuery(computed(function () {
        return {
          id: Number(props.fund.id)
        };
      }), {
        fetchPolicy: 'cache-and-network',
        nextFetchPolicy: 'cache-first'
      }),
      loadStatus = _useGetFundSetupState.load,
      statusResult = _useGetFundSetupState.result,
      statusLoading = _useGetFundSetupState.loading;
    var statusRequested = ref(false);
    var handleStatusHover = function handleStatusHover() {
      if (statusLoading.value || statusRequested.value) return;
      statusRequested.value = true;
      loadStatus();
    };
    var formattedVolume = computed(function () {
      if (!props.fund.volume) return '—';
      return abbreviateNumber(props.fund.volume, useNuxtApp().$i18n.locale || 'en');
    });
    var _ref3 = getCurrentInstance(),
      proxy = _ref3.proxy;
    var strategyLabel = computed(function () {
      switch (props.fund.fundStrategy) {
        case FundStrategy.Article_6:
          return proxy.$t('pillArticle6');
        case FundStrategy.Article_8:
          return proxy.$t('pillArticle8');
        case FundStrategy.Article_8Plus:
          return proxy.$t('pillArticle8Plus');
        case FundStrategy.Article_9:
          return proxy.$t('pillArticle9');
        default:
          return null;
      }
    });
    var showEsCharacteristicsChip = computed(function () {
      if (!props.fund.esCharacteristics) return false;
      return props.fund.fundStrategy === FundStrategy.Article_8 || props.fund.fundStrategy === FundStrategy.Article_8Plus;
    });
    var showSustainableObjectivesChip = computed(function () {
      if (props.fund.sustainableObjectives && props.fund.sustainableObjectives.length > 0) {
        return true;
      }
      return props.fund.fundStrategy === FundStrategy.Article_8Plus || props.fund.fundStrategy === FundStrategy.Article_9;
    });
    var hasEuTaxonomy = computed(function () {
      var objectives = props.fund.sustainableObjectives || [];
      return objectives.some(function (obj) {
        return obj && obj.isEnvironmentalGoal && (obj.doCheckEuTaxonomyAlignment || obj.euTaxonomyConceptId || obj.euTaxonomyConcept);
      });
    });
    var completionValue = computed(function () {
      var _statusResult$value$f, _statusResult$value, _statusResult$value$f2, _statusResult$value$f3;
      return (_statusResult$value$f = (_statusResult$value = statusResult.value) === null || _statusResult$value === void 0 ? void 0 : (_statusResult$value$f2 = _statusResult$value.fundSetupState) === null || _statusResult$value$f2 === void 0 ? void 0 : (_statusResult$value$f3 = _statusResult$value$f2.completion) === null || _statusResult$value$f3 === void 0 ? void 0 : _statusResult$value$f3.value) !== null && _statusResult$value$f !== void 0 ? _statusResult$value$f : 0;
    });
    var isComplete = computed(function () {
      return completionValue.value >= 1;
    });
    var completionSections = computed(function () {
      var _statusResult$value$f4, _statusResult$value2, _statusResult$value2$, _statusResult$value2$2;
      var items = (_statusResult$value$f4 = (_statusResult$value2 = statusResult.value) === null || _statusResult$value2 === void 0 ? void 0 : (_statusResult$value2$ = _statusResult$value2.fundSetupState) === null || _statusResult$value2$ === void 0 ? void 0 : (_statusResult$value2$2 = _statusResult$value2$.completion) === null || _statusResult$value2$2 === void 0 ? void 0 : _statusResult$value2$2.items) !== null && _statusResult$value$f4 !== void 0 ? _statusResult$value$f4 : [];
      return items.filter(function (section) {
        return section.applicable !== false && isFundSetupCompletionLeafKey(section.key);
      });
    });
    var isInSync = computed(function () {
      var _statusResult$value$f5, _statusResult$value3, _statusResult$value3$;
      return (_statusResult$value$f5 = (_statusResult$value3 = statusResult.value) === null || _statusResult$value3 === void 0 ? void 0 : (_statusResult$value3$ = _statusResult$value3.fundSetupState) === null || _statusResult$value3$ === void 0 ? void 0 : _statusResult$value3$.isInSync) !== null && _statusResult$value$f5 !== void 0 ? _statusResult$value$f5 : false;
    });
    var syncState = computed(function () {
      var _statusResult$value$f6, _statusResult$value4, _statusResult$value4$;
      return (_statusResult$value$f6 = (_statusResult$value4 = statusResult.value) === null || _statusResult$value4 === void 0 ? void 0 : (_statusResult$value4$ = _statusResult$value4.fundSetupState) === null || _statusResult$value4$ === void 0 ? void 0 : _statusResult$value4$.syncState) !== null && _statusResult$value$f6 !== void 0 ? _statusResult$value$f6 : null;
    });
    var statusLabel = computed(function () {
      if (!statusRequested.value && !statusLoading.value) {
        return proxy.$t('statusHoverToLoad');
      }
      return proxy.$t('statusIncomplete');
    });
    var statusChipStyle = computed(function () {
      if (statusLoading.value) {
        return 'background-color:#f1f5f9;color:#334155;';
      }
      if (!statusRequested.value) {
        return 'background-color:#f1f5f9;color:#334155;';
      }
      return isComplete.value ? 'background-color:#e6f4ee;color:#0d7d4a;' : 'background-color:#fff4e6;color:#b86e00;';
    });
    var strategyChipStyle = 'background-color:#e8f0ff;color:#5188ff;';
    var pendingCounts = computed(function () {
      var _state$esgQuestionnai, _state$esgQuestionnai2, _state$assignmentsToA, _state$assignmentsToA2, _state$fundAssignment, _state$fundAssignment2, _state$fundAggregatio, _state$fundAggregatio2, _state$moduleUpdates$, _state$moduleUpdates;
      var state = syncState.value;
      if (!state) {
        return {
          total: 0,
          esgQuestionnaires: 0,
          datapointKpis: 0,
          aggregationKpis: 0,
          modules: 0
        };
      }
      var esgQuestionnaires = (_state$esgQuestionnai = (_state$esgQuestionnai2 = state.esgQuestionnairesToAdd) === null || _state$esgQuestionnai2 === void 0 ? void 0 : _state$esgQuestionnai2.length) !== null && _state$esgQuestionnai !== void 0 ? _state$esgQuestionnai : 0;
      var datapointKpis = ((_state$assignmentsToA = (_state$assignmentsToA2 = state.assignmentsToAdd) === null || _state$assignmentsToA2 === void 0 ? void 0 : _state$assignmentsToA2.length) !== null && _state$assignmentsToA !== void 0 ? _state$assignmentsToA : 0) + ((_state$fundAssignment = (_state$fundAssignment2 = state.fundAssignmentsToAdd) === null || _state$fundAssignment2 === void 0 ? void 0 : _state$fundAssignment2.length) !== null && _state$fundAssignment !== void 0 ? _state$fundAssignment : 0);
      var aggregationKpis = (_state$fundAggregatio = (_state$fundAggregatio2 = state.fundAggregationsToAdd) === null || _state$fundAggregatio2 === void 0 ? void 0 : _state$fundAggregatio2.length) !== null && _state$fundAggregatio !== void 0 ? _state$fundAggregatio : 0;
      var modules = (_state$moduleUpdates$ = (_state$moduleUpdates = state.moduleUpdates) === null || _state$moduleUpdates === void 0 ? void 0 : _state$moduleUpdates.length) !== null && _state$moduleUpdates$ !== void 0 ? _state$moduleUpdates$ : 0;
      var total = esgQuestionnaires + datapointKpis + aggregationKpis + modules;
      return {
        total: total,
        esgQuestionnaires: esgQuestionnaires,
        datapointKpis: datapointKpis,
        aggregationKpis: aggregationKpis,
        modules: modules
      };
    });
    var pendingTotal = computed(function () {
      return pendingCounts.value.total;
    });
    var pendingText = computed(function () {
      return !statusRequested.value && !statusLoading.value ? '' : pendingTotal.value > 0 ? "".concat(pendingTotal.value, " changes pending") : proxy.$t('noChangesPending');
    });
    var _useDelFundsMutation = useDelFundsMutation(),
      delFunds = _useDelFundsMutation.mutate;
    var deleteDialog = ref(false);
    var deleteNameInput = ref('');
    var deleting = ref(false);
    var fundNameForConfirm = computed(function () {
      return props.fund.name || 'Unnamed fund';
    });
    var canConfirmDelete = computed(function () {
      return deleteNameInput.value.trim() === fundNameForConfirm.value;
    });
    var openDeleteDialog = function openDeleteDialog() {
      deleteNameInput.value = '';
      deleteDialog.value = true;
    };
    var closeDeleteDialog = function closeDeleteDialog() {
      deleteDialog.value = false;
    };
    var confirmDelete = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!canConfirmDelete.value || deleting.value)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              deleting.value = true;
              _context.prev = 3;
              _context.next = 6;
              return delFunds({
                ids: [Number(props.fund.id)]
              });
            case 6:
              deleteDialog.value = false;
              emit('deleted');
            case 8:
              _context.prev = 8;
              deleting.value = false;
              return _context.finish(8);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3,, 8, 11]]);
      }));
      return function confirmDelete() {
        return _ref4.apply(this, arguments);
      };
    }();
    return {
      __sfc: true,
      props: props,
      emit: emit,
      companyCount: companyCount,
      ventureNames: ventureNames,
      accountResult: accountResult,
      account: account,
      portfolioTotalCompanies: portfolioTotalCompanies,
      loadStatus: loadStatus,
      statusResult: statusResult,
      statusLoading: statusLoading,
      statusRequested: statusRequested,
      handleStatusHover: handleStatusHover,
      formattedVolume: formattedVolume,
      proxy: proxy,
      strategyLabel: strategyLabel,
      showEsCharacteristicsChip: showEsCharacteristicsChip,
      showSustainableObjectivesChip: showSustainableObjectivesChip,
      hasEuTaxonomy: hasEuTaxonomy,
      completionValue: completionValue,
      isComplete: isComplete,
      completionSections: completionSections,
      isInSync: isInSync,
      syncState: syncState,
      statusLabel: statusLabel,
      statusChipStyle: statusChipStyle,
      strategyChipStyle: strategyChipStyle,
      pendingCounts: pendingCounts,
      pendingTotal: pendingTotal,
      pendingText: pendingText,
      delFunds: delFunds,
      deleteDialog: deleteDialog,
      deleteNameInput: deleteNameInput,
      deleting: deleting,
      fundNameForConfirm: fundNameForConfirm,
      canConfirmDelete: canConfirmDelete,
      openDeleteDialog: openDeleteDialog,
      closeDeleteDialog: closeDeleteDialog,
      confirmDelete: confirmDelete,
      sustainableObjectiveFormCompletionSectionLabelKey: sustainableObjectiveFormCompletionSectionLabelKey
    };
  }
});